import Vue from 'vue'

import Amplify, * as AmplifyModules from 'aws-amplify'
import AmplifyPlugin from 'aws-amplify-vue'
import awsconfig from '../aws-exports'
Amplify.configure(awsconfig);

import {Auth,} from 'aws-amplify'

// Amplify.configure({
//     Auth: {
//
//         // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
//         identityPoolId: awsconfig.aws_cognito_identity_pool_id,
//
//         // REQUIRED - Amazon Cognito Region
//         region: awsconfig.aws_cognito_region,
//
//         // // OPTIONAL - Amazon Cognito User Pool ID
//         userPoolId: awsconfig.aws_user_pools_id,
//
//         // // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
//         userPoolWebClientId: awsconfig.aws_user_pools_web_client_id,
//
//         // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
//         mandatorySignIn: false,
//
//         // // OPTIONAL - Configuration for cookie storage
//         // // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
//         // cookieStorage: {
//         //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
//         //     domain: 'localhost',
//         //     // // // OPTIONAL - Cookie path
//         //     // // path: '/',
//         //     // // OPTIONAL - Cookie expiration in days
//         //     // expires: 365,
//         //     // // OPTIONAL - Cookie secure flag
//         //     // // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
//         //     // secure: true
//         // },
//
//         // // OPTIONAL - customized storage object
//         // storage: new MyStorage(),
//         //
//         // // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
//         // authenticationFlowType: 'USER_PASSWORD_AUTH'
//     }
// });

// You can get the current config object
const currentConfig = Auth.configure();

// AmplifyModules.I18n.setLanguage('ko')
// const dict = {
//   'ko': {
//     'Sign in to your account': '로그인하십시오.',
//   },
//   'fr': {
//     'Sign In': 'Se connecter',
//     'Sign Up': "S'inscrire",
//   },
//   'es': {
//     'Sign In': 'Registrarse',
//     'Sign Up': 'Regístrate'
//   }
// }
// AmplifyModules.I18n.putVocabularies(dict)
Vue.use(AmplifyPlugin, AmplifyModules)

// class MyClass {
//   constructor() {
//     AmplifyModules.Hub.listen('auth', (data) => {
//       const { payload } = data;
//       this.onAuthEvent(payload);
//       console.log('A new auth event has happened: ', data.payload.data.username + ' has ' + data.payload.event);
//     })
//   }
//
//   onAuthEvent(payload) {
//     // ... your implementation
//   }
// }
// new MyClass();



// // import Amplify, * as AmplifyModules from 'aws-amplify'
// // import AmplifyPlugin from 'aws-amplify-vue'
// import AwsExports from './aws-exports'
// import SignIn from 'aws-amplify-vue/src/components/authenticator/SignIn.vue'
// import SignUp from 'aws-amplify-vue/src/components/authenticator/SignUp.vue'
// import SignOut from 'aws-amplify-vue/src/components/authenticator/SignOut.vue'
// import ConfirmSignUp from 'aws-amplify-vue/src/components/authenticator/ConfirmSignUp.vue'
// import ConfirmSignIn from 'aws-amplify-vue/src/components/authenticator/ConfirmSignIn.vue'
// import ForgotPassword from 'aws-amplify-vue/src/components/authenticator/ForgotPassword.vue'
// import Authenticator from 'aws-amplify-vue/src/components/authenticator/Authenticator.vue'
// import SetMfa from 'aws-amplify-vue/src/components/authenticator/SetMFA.vue'
// import RequireNewPassword from 'aws-amplify-vue/src/components/authenticator/RequireNewPassword.vue'
// import UsernameField from 'aws-amplify-vue/src/components/authenticator/UsernameField'
//
// Amplify.configure(AwsExports)
//
// Vue.prototype.$Amplify = Amplify
// Vue.use(AmplifyPlugin, AmplifyModules)
//
// Vue.mixin({
//   components: {
//     amplifyUsernameField: UsernameField,
//     amplifySignIn: SignIn,
//     amplifySignUp: SignUp,
//     amplifySignOut: SignOut,
//     amplifyConfirmSignUp: ConfirmSignUp,
//     amplifyConfirmSignIn: ConfirmSignIn,
//     amplifyForgotPassword: ForgotPassword,
//     amplifyAuthenticator: Authenticator,
//     amplifySetMfa: SetMfa,
//     amplifyRequireNewPassword: RequireNewPassword
//   }
// })

// Vue.use(AmplifyPlugin, AmplifyModules)

// import Amplify, * as AmplifyModules from 'aws-amplify'
// import AmplifyPlugin from 'aws-amplify-vue'
// import AwsExports from '../aws-exports'
// import SignIn from 'aws-amplify-vue/src/components/authenticator/SignIn.vue'
// import SignUp from 'aws-amplify-vue/src/components/authenticator/SignUp.vue'
// import SignOut from 'aws-amplify-vue/src/components/authenticator/SignOut.vue'
// import ConfirmSignUp from 'aws-amplify-vue/src/components/authenticator/ConfirmSignUp.vue'
// import ConfirmSignIn from 'aws-amplify-vue/src/components/authenticator/ConfirmSignIn.vue'
// import ForgotPassword from 'aws-amplify-vue/src/components/authenticator/ForgotPassword.vue'
// import Authenticator from 'aws-amplify-vue/src/components/authenticator/Authenticator.vue'
// import SetMfa from 'aws-amplify-vue/src/components/authenticator/SetMFA.vue'
// import RequireNewPassword from 'aws-amplify-vue/src/components/authenticator/RequireNewPassword.vue'
//
// Amplify.configure(AwsExports)
//
// export default ({ Vue }) => {
//   Vue.prototype.$Amplify = Amplify
//   Vue.use(AmplifyPlugin, AmplifyModules)
//
//   Vue.mixin({
//     components: {
//       amplifySignIn: SignIn,
//       amplifySignUp: SignUp,
//       amplifySignOut: SignOut,
//       amplifyConfirmSignUp: ConfirmSignUp,
//       amplifyConfirmSignIn: ConfirmSignIn,
//       amplifyForgotPassword: ForgotPassword,
//       amplifyAuthenticator: Authenticator,
//       amplifySetMfa: SetMfa,
//       amplifyRequireNewPassword: RequireNewPassword
//     }
//   })
// }
